import React from 'react';
import { Link } from 'react-router-dom';
import { Checkbox } from '@mui/material';
import { Body3 } from '../../themes/typography';

function EventPublishDrawer({ checked, setChecked }) {
    return (
        <React.Fragment>
            <div style={styles.termsAndConditionContainer}>
                <Checkbox
                    size="small"
                    sx={{
                        color: '#26c1e8',
                        padding: '0',
                        '&.Mui-checked': {
                            color: '#26c1e8'
                        }
                    }}
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                />
                <Body3>
                    By clicking "Publish", I acknowledge that I have read & accept the{' '}
                    <Link to="/terms-and-conditions" style={styles.tAndCLink}>
                        Terms and Conditions
                    </Link>
                    .
                </Body3>
            </div>
        </React.Fragment>
    );
}

export default EventPublishDrawer;

const styles = {
    termsAndConditionContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '0.75rem',
        padding: '1rem'
    },
    tAndCLink: {
        color: '#26c1e8',
        textDecoration: 'underline'
    }
};
